import React, {useState, useRef, useEffect, useCallback} from "react";
import { ReactComponent as ArrowDown } from "assets/svgs/accordion-arrow.svg";
import Link from "@helpers/link";
import useObserveSize from "@root/hooks/useObserveSize";
import Icon from "@_components/Icon/icon";
import Image from "@root/components/image";

const AccordionMenu = ({ items, onChange, activeItems=[], allowUrlClick=false }) => {
    if (!items) return null;

    const [openItems, setOpenItems] = useState([]);
    const [isUserInteraction, setIsUserInteraction] = useState(false);
    const subItemsRefs = useRef([]);


    useObserveSize(subItemsRefs.current, (element) => {
        const subItemsHeight = element.scrollHeight;
        element.style.setProperty("--max-height", `${subItemsHeight}px`);
    });

    const handleItemClick = (e, item, pathItems) => {
        setIsUserInteraction(true);

        if(openItems.includes(item.id)) {
            setOpenItems(activeItems?.filter((id) => id !== item.id));
        } else {
            setOpenItems(pathItems ? pathItems.map((pathItem) => pathItem.id) : [item.id]);
        }

        if (onChange) onChange(e, item, pathItems ? pathItems.map((pathItem) => pathItem.id) : [item.id]);
    };

    useEffect(() => {
        if (!isUserInteraction && activeItems.length > 0) {
            setOpenItems(activeItems);
        }
        setIsUserInteraction(false);
    }, [activeItems]);

    const isOpenItem = useCallback((id) => openItems.includes(id), [openItems]);
    const isActiveItem = useCallback((id) => activeItems?.includes(id), [activeItems]);

    return (
        <div className="accordion-menu">
            <div className="accordion-menu__inner">
                {items.map((item, index) => (
                    <div
                        className={`
                            accordion-menu__item 
                            ${isOpenItem(item.id) ? "accordion-menu__item--open" : ""} 
                            ${isActiveItem(item.id) ? "accordion-menu__item--active" : ""} 
                            ${item.subItems?.length === 0 ? "accordion-menu__item--no-sub-items" : ""}
                        `}
                        key={item.title}
                    >
                        <div className="accordion-menu__item-header" onClick={(e) => !item.url || !allowUrlClick ? handleItemClick(e, item) : null }>
                            <Image className="accordion-menu__item-image" image={item.image} alt={item.title} />
                            {item.url ? (
                                <Link to={item.url} className="accordion-menu__item-title" onClick={(e) => !allowUrlClick ? handleItemClick(e, item) : null }>
                                    {item.title}
                                </Link>
                            ):(
                                <div className="accordion-menu__item-title">
                                    {item.title}
                                </div>
                            )}
                            <div className="accordion-menu__toggle-icon" onClick={(e) => handleItemClick(e, item)}>
                                <Icon icon="chevron-down" size={20} />
                            </div>
                        </div>
                        {item.subItems?.length === 0 ? null : (
                            <div
                                className="accordion-menu__sub-items-wrapper"
                                // eslint-disable-next-line no-return-assign
                                ref={(elf) => subItemsRefs.current[index] = elf}
                            >
                                <div className="accordion-menu__sub-items">
                                    {item.subItems?.map((subItem) => (
                                        <Link to={subItem?.url} className={`accordion-menu__sub-item ${isActiveItem(subItem?.id) ? "accordion-menu__sub-item--active" : ""} `} key={subItem?.id} onClick={(e) => handleItemClick(e, subItem, [item, subItem])}>
                                            {subItem?.title}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccordionMenu;
